import { render, staticRenderFns } from "./TheTabImage.vue?vue&type=template&id=0345b9ec"
import script from "./TheTabImage.vue?vue&type=script&lang=js"
export * from "./TheTabImage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports